module.exports = __webpack_public_path__ + "static/media/allCrops.9be5202a.webp";